__turbopack_context__.v({
  "ButtonContainer": "GvbwMq_ButtonContainer",
  "ContentContainer": "GvbwMq_ContentContainer",
  "Header": "GvbwMq_Header",
  "LottieContainer": "GvbwMq_LottieContainer",
  "MessageContainer": "GvbwMq_MessageContainer",
  "PageContainer": "GvbwMq_PageContainer",
  "SellerContainer": "GvbwMq_SellerContainer",
  "SellerTitle": "GvbwMq_SellerTitle",
});
